// Lista de módulos disponibles para el alumno (de su nivel) o todos para profe/admin.

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/atoms/Badge';
import { Icon } from '@/components/atoms/Icon';
import { Spinner } from '@/components/atoms/Spinner';
import { Header } from '@/components/organisms/Header';
import { ApiError } from '@/services/api';
import { listModules, type ModuleListItem } from '@/services/lessons';
import styles from './Lecciones.module.scss';

export function ModulesList() {
  const [items, setItems] = useState<ModuleListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    listModules()
      .then((rows) => { if (!cancelled) setItems(rows); })
      .catch((e) => !cancelled && setError(e instanceof ApiError ? e.message : e instanceof Error ? e.message : 'Error'))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <Header title="Lecciones" />
      <main className={styles.main}>
        {loading ? (
          <div className={styles.center}><Spinner size="lg" /></div>
        ) : error ? (
          <p className={styles.error}>{error}</p>
        ) : items.length === 0 ? (
          <div className={styles.empty}>
            <h2>No tienes módulos disponibles</h2>
            <p>Asegúrate de tener un nivel asignado. Si crees que es un error, contacta con el equipo.</p>
          </div>
        ) : (
          <ul className={styles.cardGrid}>
            {items.map((m) => (
              <li key={m.id} className={styles.card}>
                <Link to={`/lecciones/modulo/${m.id}`} className={styles.cardLink}>
                  <div className={styles.cardHeader}>
                    <Badge tone="accent">{m.level_label}</Badge>
                    {m.year && <span className={styles.muted}>{m.year}</span>}
                  </div>
                  <h3 className={styles.cardTitle}>{m.title}</h3>
                  {m.code && <p className={styles.muted}>{m.code}</p>}
                  <div className={styles.cardFooter}>
                    <span className={styles.lessonCount}>
                      <Icon name="book" size={14} />
                      {m.lesson_count} {m.lesson_count === 1 ? 'lección' : 'lecciones'}
                    </span>
                    <Icon name="chevron-right" size={16} />
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </>
  );
}
